module.exports = __webpack_public_path__ + "img/김휘아 아티스트.8677f3cf.jpg";